module.exports = __webpack_public_path__ + "static/media/SalonsSelected.eff2d9c2.svg";